import {customElement, queryAll, state} from "lit/decorators.js";
import {html, type TemplateResult} from "lit";
import {keyed} from "lit/directives/keyed.js";
import {SearchFacade} from "../searchFacade";
import {resolve} from "../../../../container";
import type {FeedEntry} from "../../feedEntry";
import type {SearchTileData} from "../searchGroup";
import {EopSiteSearchTile} from "./siteSearchTile";
import type {Maybe} from "../../../../bootstrap/common/types";
import {UnLitElement} from "../../../../common/elements";
import type {DirectiveResult} from "lit/directive";


@customElement("eop-site-search-tiles")
export class EopSiteSearchTiles extends UnLitElement {

    @state()
    private tileDatas: SearchTileData[];

    @queryAll("eop-site-search-tile")
    private tiles: NodeListOf<EopSiteSearchTile>;

    public constructor(private searchFacade: SearchFacade = resolve(SearchFacade)) {
        super();
        this.tileDatas = [];
    }

    public connectedCallback(): void {
        super.connectedCallback();

        this.searchFacade.onChangeGroup(group => {
            this.tileDatas = this.mapEntries(group.entries, group.name);
        });
        this.searchFacade.onNewEntries(group => {
            this.tileDatas = this.mapEntries(group.entries, group.name);
        });
    }

    public render(): TemplateResult {
        return html`
            <div class="tiles">${(this.renderTiles())}</div>
        `;
    }

    private renderTiles(): DirectiveResult[] {
        return this.tileDatas.map(tileData => keyed(tileData.entry.data.url + tileData.groupName, html`
            <eop-site-search-tile .entry=${tileData.entry} .groupName=${tileData.groupName} class="tile"></eop-site-search-tile>`));
    }

    private mapEntries(entries: FeedEntry[], groupName: string): SearchTileData[] {
        return entries.map(entry => ({entry: entry, groupName: groupName}));
    }

    public lastFocusable(): Maybe<HTMLElement> {
        return Array.from(this.tiles).lastElement()?.lastFocusable();
    }
}